import { render, staticRenderFns } from "./JcomTableMembersList.vue?vue&type=template&id=d68d06a6"
import script from "./JcomTableMembersList.vue?vue&type=script&lang=js"
export * from "./JcomTableMembersList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports